import React, { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import LagerEntnahmeSchein from './LagerEntnahmeSchein';
import LieferSchein from './Lieferschein';

const PrintableDelieveryNote = React.forwardRef<
    HTMLDivElement,
    { dataLagerEntnahmeSchein: any; dataLieferschein: any }
>(({ dataLagerEntnahmeSchein, dataLieferschein }, ref) => {
    const visibleLagerentnahmeSchein = dataLagerEntnahmeSchein?.products?.length > 0;
    const visibleLieferschein = dataLieferschein?.products?.length > 0;

    return (
        <div ref={ref}>
            {visibleLagerentnahmeSchein && (
                <div className="print-page">
                    <LagerEntnahmeSchein {...dataLagerEntnahmeSchein} />
                </div>
            )}
            {visibleLieferschein && (
                <div className="print-page">
                    <LieferSchein {...dataLieferschein} />
                </div>
            )}
        </div>
    );
});

const PrintDelieveryNoteButton = ({ store, onArchived }: any) => {
    const componentRef = useRef(null);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handlePrint: any = useReactToPrint({
        contentRef: componentRef,
        documentTitle: 'Lieferscheine drucken',
        onAfterPrint() {
            setShowConfirmation(true); // Show confirmation dialog after printing
        },
    });

    const handleSave: any = async () => {
        if ((await store.onSaveOrder()) === true) {
            handlePrint();
        }
    };

    const handleConfirm = async () => {
        setShowConfirmation(false); // Close the dialog
        if ((await store.archiveOrder()) === true) {
            // Call archiveOrder if confirmed
            onArchived(); // Call the onArchived callback
        }
    };

    const handleCancel = () => {
        setShowConfirmation(false); // Close the dialog without archiving
    };

    return (
        <>
            <Button
                label="Lieferschein drucken"
                icon="pi pi-print"
                onClick={store.hasChanged ? handleSave : handlePrint}
                disabled={!store.isPrintable}
            />

            <div style={{ display: 'none' }}>
                <PrintableDelieveryNote
                    ref={componentRef}
                    dataLagerEntnahmeSchein={store.lagerEntnahmeschein}
                    dataLieferschein={store.lieferschein}
                />
            </div>

            {/* Confirmation Dialog */}
            <Dialog
                visible={showConfirmation}
                header="Bestätigung"
                onHide={handleCancel}
                footer={
                    <div>
                        <Button
                            label="Ja"
                            icon="pi pi-check"
                            onClick={handleConfirm}
                            autoFocus
                        />
                        <Button
                            label="Nein"
                            icon="pi pi-times"
                            onClick={handleCancel}
                            className="p-button-text"
                        />
                    </div>
                }
            >
                <p>Haben Sie die Dokumente gedruckt?</p>
            </Dialog>
        </>
    );
};

export default PrintDelieveryNoteButton;
